import { useTranslation } from 'react-i18next'

import { TourAppealDetails } from 'shared/api/tours/buy-ticket'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { dateFormat } from 'shared/lib/dateFormat'

export const useMyOrderDetailsHeaderMeta = (
  appealDetails: TourAppealDetails | null,
) => {
  const { t } = useTranslation()
  const session = appealDetails?.hotel_search_session
  const title = appealDetails
    ? `${appealDetails.hotel?.state_name ?? ''} - ${appealDetails.hotel?.region_name ?? ''}`
    : ''

  const subtitle =
    session?.checkin_date && session?.checkout_date
      ? `${dateFormat(session.checkin_date, DATE_FORMAT_LIST.DATE_MONTH_SHORT)} - ${dateFormat(session.checkout_date, DATE_FORMAT_LIST.DATE_MONTH_SHORT)} • ${t('tours_block.nights_short', { night: session.nights ?? 0 })} • ${t('tours_block.tours_count', { count: session.adult + session.child })}`
      : ''

  return { title, subtitle }
}
